import styled from 'styled-components'
import React, { useState } from 'react'
import { requestTranslation } from '@futures-platform/i18n'

const TranslationBtn = ({
  // color = '#b0b0b0',
  width = '39px',
  height = '39px',
  handler,
  isNewsBookMarked,
  widthOfView,
  newsData,
  isAuthed,
}) => {
  const [isHover, setIsHover] = useState(false)
  const isMobile = /Mobi/.test(window.navigator.userAgent)

  return (
    <FlagWrapper
      onMouseOver={() => {
        setIsHover(() => true)
      }}
      onMouseOut={() => {
        setIsHover(() => false)
      }}
      id="news-bookmark"
      onClick={handler}
      style={{
        // marginTop: widthOfView > 600 ? 0 : '8px',
        // marginTop: '4px',
        cursor: 'pointer',
      }}>
      {!isAuthed ? (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <mask
            id="mask0_4248_11880"
            style={{
              maskType: 'luminance',
            }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="36">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_4248_11880)">
            <rect width="36" height="36" fill="#E8EBEB" />
            <circle cx="18" cy="18" r="17" fill="white" />
          </g>
          <ellipse cx="18" cy="24" rx="9" ry="2" fill="#C2D0D7" />
          <path
            d="M14.5 15C13.8 15 13.7 15.7 14 16L17.3 19.3C17.8 19.8 18.2 19.8 18.7 19.3L22.0001 16C22.3001 15.7 22.2001 15 21.5001 15H14.5Z"
            fill="#C2D0D7"
          />
          <path
            d="M19 10.1247C19 8.62512 17 8.62512 17 10.1248L17 16.1247C17 17.6251 19 17.6251 19 16.1247L19 10.1247Z"
            fill="#C2D0D7"
          />
        </svg>
      ) : (
        <>
          {!!isNewsBookMarked && (
            <>
              {!isHover || !!isMobile ? (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <mask
                    id="mask0_4248_11883"
                    style={{
                      maskType: 'luminance',
                    }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4248_11883)">
                    <rect width="36" height="36" fill="#00C3FF" />
                    <circle cx="18" cy="18" r="17" fill="white" />
                  </g>
                  <ellipse cx="18" cy="24" rx="9" ry="2" fill="#00C3FF" />
                  <path
                    d="M14.5 15C13.8 15 13.7 15.7 14 16L17.3 19.3C17.8 19.8 18.2 19.8 18.7 19.3L22.0001 16C22.3001 15.7 22.2001 15 21.5001 15H14.5Z"
                    fill="#00C3FF"
                  />
                  <path
                    d="M19 10.1247C19 8.62512 17 8.62512 17 10.1248L17 16.1247C17 17.6251 19 17.6251 19 16.1247L19 10.1247Z"
                    fill="#00C3FF"
                  />
                </svg>
              ) : (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <mask
                    id="mask0_4248_11886"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4248_11886)">
                    <rect width="36" height="36" fill="#689AB9" />
                    <circle cx="18" cy="18" r="17" fill="white" />
                  </g>
                  <ellipse cx="18" cy="24" rx="9" ry="2" fill="#689AB9" />
                  <path
                    d="M14.5 15C13.8 15 13.7 15.7 14 16L17.3 19.3C17.8 19.8 18.2 19.8 18.7 19.3L22.0001 16C22.3001 15.7 22.2001 15 21.5001 15H14.5Z"
                    fill="#689AB9"
                  />
                  <path
                    d="M19 10.1247C19 8.62512 17 8.62512 17 10.1248L17 16.1247C17 17.6251 19 17.6251 19 16.1247L19 10.1247Z"
                    fill="#689AB9"
                  />
                </svg>
              )}
            </>
          )}
          {!isNewsBookMarked && (
            <>
              {!isHover || !!isMobile ? (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <mask
                    id="mask0_4248_11889"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4248_11889)">
                    <rect width="36" height="36" fill="#C2D0D7" />
                    <circle cx="18" cy="18" r="17" fill="white" />
                  </g>
                  <ellipse cx="18" cy="24" rx="9" ry="2" fill="#637282" />
                  <path
                    d="M14.5 15C13.8 15 13.7 15.7 14 16L17.3 19.3C17.8 19.8 18.2 19.8 18.7 19.3L22.0001 16C22.3001 15.7 22.2001 15 21.5001 15H14.5Z"
                    fill="#637282"
                  />
                  <path
                    d="M19 10.1247C19 8.62512 17 8.62512 17 10.1248L17 16.1247C17 17.6251 19 17.6251 19 16.1247L19 10.1247Z"
                    fill="#637282"
                  />
                </svg>
              ) : (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <mask
                    id="mask0_4248_11886"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4248_11886)">
                    <rect width="36" height="36" fill="#689AB9" />
                    <circle cx="18" cy="18" r="17" fill="white" />
                  </g>
                  <ellipse cx="18" cy="24" rx="9" ry="2" fill="#689AB9" />
                  <path
                    d="M14.5 15C13.8 15 13.7 15.7 14 16L17.3 19.3C17.8 19.8 18.2 19.8 18.7 19.3L22.0001 16C22.3001 15.7 22.2001 15 21.5001 15H14.5Z"
                    fill="#689AB9"
                  />
                  <path
                    d="M19 10.1247C19 8.62512 17 8.62512 17 10.1248L17 16.1247C17 17.6251 19 17.6251 19 16.1247L19 10.1247Z"
                    fill="#689AB9"
                  />
                </svg>
              )}
            </>
          )}
        </>
      )}
    </FlagWrapper>
  )
}

export default TranslationBtn

const FlagWrapper = styled.div`
  background: transparent;
  // border-radius: 100%;
  // box-shadow: 0px 2px 3px 0px rgb(0 0 0 / 10%);
  // width: 36px;
  // height: 36px;
  // & svg:last-child {
  //   display: none;
  //   width: 0;
  //   height: 0;
  // }
  // &:hover svg:last-child {
  //   display: block;
  //   width: 36px;
  //   height: 36px;
  // }
  // &:hover svg:first-child {
  //   display: none;
  // }
`

export const EditButton = styled.img`
  cursor: pointer;
  background-color: transparent;
  color: transparent;
  width: 150px;
  height: 30px;
`
